/**
 * Get Master Compliance Types Use Case
 */

import { ComplianceTypeEntity } from "../../../../../compliance/domain/entities";
import { TenantComplianceRepository } from "../../../../../compliance/domain/repositories";

export class GetMasterTypesUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(): Promise<ComplianceTypeEntity[]> {
    return await this.repository.getMasterTypes();
  }
}

